export default {
  countCells: 13,
  massive: [
    {
      dataField: 'founder',
      cols: 1,
      rows: 1,
      text: 'ID',
      class: 'd-flex align-center  ',
      order: 0,
      variable: true,
      template: (r) => r?.id
    },
    {
      dataField: 'founder1',
      cols: 10,
      rows: 1,
      text: 'Наименование',
      class: 'd-flex flex-row justify-space-between align-center',
      headerClass: '  ',
      styles: 'justify-content: unset;',
      headerStyles: `min-width: 510px;`,
      order: 0,
      variable: true,
      template: (r) => (r?.name + '<br>' +
          `<span class="help-text">${r.coUgsList.map(el => el.ugsCode).join(', ')}</span>`)
    },
    {
      dataField: 'blocks',
      cols: 1,
      rows: 1,
      order: 2,
      variable: true,
      class: `d-flex flex-row justify-center`,
      headerStyles: `min-width: 81px;`,
      text: `<span>Этап 1</span>  <span>Этап 2</span>`,
    },
    {
      dataField: 'actions',
      cols: 1,
      rows: 1,
      order: 3,
      variable: true,
      class: ``,
      headerStyles: `min-width:110px;`,
      text: ``,
    },
  ]
}
